module.exports = __webpack_public_path__ + "static/img/1_2.a0c1bb3c.jpg";